
    // this file was auto generated by python script
    import Folder from './Folder';
    export default Folder;
    